import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _assertThisInitialized from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";

/**
 * An error that occurred while calling a RPC method.
 */
export var RpcError = /*#__PURE__*/function (_Error) {
  _inherits(RpcError, _Error);

  var _super = _createSuper(RpcError);

  function RpcError(message) {
    var _this;

    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UNKNOWN';
    var meta = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, RpcError);

    _this = _super.call(this, message);
    _this.name = 'RpcError'; // see https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example

    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof RpcError ? this.constructor : void 0).prototype);
    _this.code = code;
    _this.meta = meta !== null && meta !== void 0 ? meta : {};
    return _this;
  }

  _createClass(RpcError, [{
    key: "toString",
    value: function toString() {
      var l = [this.name + ': ' + this.message];

      if (this.code) {
        l.push('');
        l.push('Code: ' + this.code);
      }

      if (this.serviceName && this.methodName) {
        l.push('Method: ' + this.serviceName + '/' + this.methodName);
      }

      var m = Object.entries(this.meta);

      if (m.length) {
        l.push('');
        l.push('Meta:');

        var _iterator = _createForOfIteratorHelper(m),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                k = _step$value[0],
                v = _step$value[1];

            l.push("  ".concat(k, ": ").concat(v));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return l.join('\n');
    }
  }]);

  return RpcError;
}( /*#__PURE__*/_wrapNativeSuper(Error));